export enum ActivityRecordVerificationStatus {
  ACTIVITY = 'ACTIVITY',
  MISSING = 'MISSING',
}
